module.exports = __webpack_public_path__ + "img/015.9fa050ef.png";